<template>
  <div id="dc_login"></div>
</template>
<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  created: function () {
    this.$router.push({
      name: 'DcTop'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcLogin.vue